var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSampleCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000013181188809964515060000000682426731346285450_);}\n\t.st2{fill:url(#SVGID_00000042005618492352854700000000084903351776716447_);}\n\t.st3{fill:url(#SVGID_00000150071274820380260250000009909456989075413680_);}\n\t.st4{fill:url(#SVGID_00000087400031495137152430000016000228544778601361_);}\n\t.st5{fill:url(#SVGID_00000085937632324093004200000002351941983259205783_);}\n\t.st6{fill:url(#SVGID_00000047744102392295418450000016958905013793117616_);}\n\t.st7{fill:url(#SVGID_00000124879277501081127040000015993523582076798345_);}\n\t.st8{fill:url(#SVGID_00000026861811142954106180000000384991051839093416_);}\n\t.st9{fill:url(#SVGID_00000108271734775242731220000002618376129287883428_);}\n\t.st10{fill:url(#SVGID_00000163795646795611002090000007111748327616586905_);}\n\t.st11{fill:url(#SVGID_00000153695438972278032580000010428840286824648334_);}\n\t.st12{fill:url(#SVGID_00000086660800651505391720000006888919717518022326_);}\n\t.st13{fill:url(#SVGID_00000078724474673719394870000002238251572042062993_);}\n\t.st14{fill:url(#SVGID_00000126312257971676622980000011303832305363713200_);}\n\t.st15{fill:url(#SVGID_00000018929302025819619450000006008660695510039487_);}\n\t.st16{fill:url(#SVGID_00000153664363163897653470000012874151102961870520_);}\n\t.st17{fill:url(#SVGID_00000114777575491187943380000009947077959406358402_);}\n\t.st18{fill:url(#SVGID_00000054968489482882597730000003111886168835400065_);}\n\t.st19{fill:url(#SVGID_00000062184785304745743220000000573460161803345307_);}\n\t.st20{fill:url(#SVGID_00000159434735964081564940000007906644580141593244_);}\n\t.st21{fill:url(#SVGID_00000043439694466196060000000001770937338421175743_);}\n\t.st22{fill:url(#SVGID_00000109741051052778452050000002599586490299525031_);}\n\t.st23{fill:url(#SVGID_00000036966399974882827160000002700016883390298796_);}\n\t.st24{fill:url(#SVGID_00000085233862588299639530000018088304194639302785_);}\n\t.st25{fill:url(#SVGID_00000022537326097492014260000009547172824144328328_);}\n\t.st26{fill:url(#SVGID_00000094600273868276840170000003376435944109790364_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 332.4991,
    x2: 514.197,
    y2: 332.4991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.2,325.1H50.1c-3-8.3-10.9-14.2-20.2-14.2c-11.9,0-21.6,9.7-21.6,21.6s9.7,21.6,21.6,21.6 c9.3,0,17.2-5.9,20.2-14.2h141.1c4,0,7.4-3.3,7.4-7.4S195.3,325.1,191.2,325.1z M29.9,341.4c-4.9,0-8.9-4-8.9-8.9 c0-4.9,4-8.9,8.9-8.9s8.9,4,8.9,8.9C38.9,337.4,34.8,341.4,29.9,341.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100341452014409758020000009385394624659072655_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 250.4378,
    x2: 514.197,
    y2: 250.4378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100341452014409758020000009385394624659072655_)"
    },
    d: "M67.8,243.6c9.3,0,17.2-5.9,20.2-14.2 h32.8v63.7c0,4,3.3,7.3,7.3,7.3h28.3c4,0,7.3-3.3,7.3-7.3c0-4-3.3-7.3-7.3-7.3h-21l-0.3-63.7c0-4-3.3-7.3-7.3-7.3 c-0.4,0-0.5-0.1-0.8,0H88c-3-8.3-10.9-14.2-20.2-14.2c-11.9,0-21.6,9.7-21.6,21.6C46.2,233.9,55.9,243.6,67.8,243.6z M67.8,213.1 c4.9,0,8.9,4,8.9,8.9c0,4.9-4,8.9-8.9,8.9c-4.9,0-8.9-4-8.9-8.9C58.9,217.1,62.9,213.1,67.8,213.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010307834398821705660000017210723835057500550_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 414.5604,
    x2: 514.197,
    y2: 414.5604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010307834398821705660000017210723835057500550_)"
    },
    d: "M156.5,364.6h-28.3c-4,0-7.3,3.3-7.3,7.3 v63.7H88c-3-8.3-10.9-14.2-20.2-14.2c-11.9,0-21.6,9.7-21.6,21.6s9.7,21.6,21.6,21.6c9.3,0,17.2-5.9,20.2-14.2H127 c0.4,0.1,0.4,0,0.8,0c4,0,7.3-3.3,7.3-7.3l0.3-63.7h21c4,0,7.3-3.3,7.3-7.3C163.8,367.9,160.5,364.6,156.5,364.6z M67.8,451.9 c-4.9,0-8.9-4-8.9-8.9c0-4.9,4-8.9,8.9-8.9c4.9,0,8.9,4,8.9,8.9C76.7,447.9,72.7,451.9,67.8,451.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093147027714778672610000014765217869620762797_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 365.9835,
    x2: 514.197,
    y2: 365.9835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 328.4,
    y: 336.4,
    style: {
      fill: "url(#SVGID_00000093147027714778672610000014765217869620762797_)"
    },
    width: 12.1,
    height: 59.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084498610596208394310000002086868889378463654_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 312.5535,
    x2: 514.197,
    y2: 312.5535
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000084498610596208394310000002086868889378463654_)"
    },
    points: "323.9,318.6 480.1,318.6  484.4,306.5 320.2,306.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009571936695786620990000018346539697140820623_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 421.5789,
    x2: 514.197,
    y2: 421.5789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 328.4,
    y: 412.8,
    style: {
      fill: "url(#SVGID_00000009571936695786620990000018346539697140820623_)"
    },
    width: 12.1,
    height: 17.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046326344404139579370000008145725594249069756_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 329.0075,
    x2: 514.197,
    y2: 329.0075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 244.1,
    y: 322.9,
    style: {
      fill: "url(#SVGID_00000046326344404139579370000008145725594249069756_)"
    },
    width: 12.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078759077910965325280000006287379834149115301_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 383.3977,
    x2: 514.197,
    y2: 383.3977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078759077910965325280000006287379834149115301_)"
    },
    d: "M359.2,430.4h17.9l0-20.3 c0,0-0.1-23,24.9-23c25,0,27.1,21.4,27.1,21.4l-0.1,21.9h15.8v-94h-85.6V430.4z M418.4,350.8h12.1v24.3h-12.1V350.8z M396,350.8 h12.1v24.3H396V350.8z M373.6,350.8h12.1v24.3h-12.1V350.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165913698650957091970000014920210185252022156_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 329.0075,
    x2: 514.197,
    y2: 329.0075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 322.9,
    style: {
      fill: "url(#SVGID_00000165913698650957091970000014920210185252022156_)"
    },
    width: 12.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104702158069865707480000018151590224259572150_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 348.4573,
    x2: 514.197,
    y2: 348.4573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 244.1,
    y: 342.4,
    style: {
      fill: "url(#SVGID_00000104702158069865707480000018151590224259572150_)"
    },
    width: 12.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004527884031915091680000001662644509704781500_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 348.4573,
    x2: 514.197,
    y2: 348.4573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 342.4,
    style: {
      fill: "url(#SVGID_00000004527884031915091680000001662644509704781500_)"
    },
    width: 12.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009568238024653430650000015818601821439836565_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 369.0381,
    x2: 514.197,
    y2: 369.0381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 244.1,
    y: 363,
    style: {
      fill: "url(#SVGID_00000009568238024653430650000015818601821439836565_)"
    },
    width: 12.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049911200498812571880000009885757912867991215_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 369.0381,
    x2: 514.197,
    y2: 369.0381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 363,
    style: {
      fill: "url(#SVGID_00000049911200498812571880000009885757912867991215_)"
    },
    width: 12.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020359486217336088680000007001520024617258892_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 365.9835,
    x2: 514.197,
    y2: 365.9835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 464.9,
    y: 336.4,
    style: {
      fill: "url(#SVGID_00000020359486217336088680000007001520024617258892_)"
    },
    width: 12.1,
    height: 59.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134933920815245590420000012604646808685344648_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 421.5789,
    x2: 514.197,
    y2: 421.5789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 464.9,
    y: 412.8,
    style: {
      fill: "url(#SVGID_00000134933920815245590420000012604646808685344648_)"
    },
    width: 12.1,
    height: 17.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142149448450016790640000001986349930987744157_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 417.2862,
    x2: 514.197,
    y2: 417.2862
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142149448450016790640000001986349930987744157_)"
    },
    d: "M402.7,404.2c-4.9,0-8.8,3.9-8.8,8.8v17.4 h17.6V413C411.5,408.1,407.5,404.2,402.7,404.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134214796667069812560000015809559058601486242_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 421.5789,
    x2: 514.197,
    y2: 421.5789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 214.1,
    y: 412.8,
    style: {
      fill: "url(#SVGID_00000134214796667069812560000015809559058601486242_)"
    },
    width: 94.3,
    height: 17.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097482206285499340670000002481485448847189662_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 209.3016,
    x2: 514.197,
    y2: 209.3016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097482206285499340670000002481485448847189662_)"
    },
    d: "M570.7,284.1h17.8l-13.7-51.2H449.1 l-40.6-40.6v-24.1l40.4,0.7l-52.5-34.3v58L344.8,244l11.1-11.1H230l-13.7,51.2H234H570.7z M560.7,248.3l5.1,18.2H349.9l53.6-53.6 l53.3,53.3h25.6l-17.9-17.9H560.7z M340.5,248.3l-18.2,18.2H239l5.1-18.2H340.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031173963813237323470000018199926803085506477_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 421.5789,
    x2: 514.197,
    y2: 421.5789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 496.3,
    y: 412.8,
    style: {
      fill: "url(#SVGID_00000031173963813237323470000018199926803085506477_)"
    },
    width: 94.3,
    height: 17.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160875702992101997060000000071303469615235997_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 348.4546,
    x2: 514.197,
    y2: 348.4546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160875702992101997060000000071303469615235997_)"
    },
    d: "M222.8,301.4v94.2h85.6v-67.3l-6.9-26.9 H222.8z M297.2,384.3H234v-71.8h58.8l4.4,17.1V384.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178183757126198892300000000033922875622561422_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 329.0075,
    x2: 514.197,
    y2: 329.0075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 548.6,
    y: 322.9,
    style: {
      fill: "url(#SVGID_00000178183757126198892300000000033922875622561422_)"
    },
    width: 12.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104693097831009626950000004830547734562772372_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 329.0075,
    x2: 514.197,
    y2: 329.0075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 520.8,
    y: 322.9,
    style: {
      fill: "url(#SVGID_00000104693097831009626950000004830547734562772372_)"
    },
    width: 12.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083807223425034345970000015862651164313882535_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 348.4573,
    x2: 514.197,
    y2: 348.4573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 548.6,
    y: 342.4,
    style: {
      fill: "url(#SVGID_00000083807223425034345970000015862651164313882535_)"
    },
    width: 12.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178173053581115873090000004529125543861234071_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 348.4573,
    x2: 514.197,
    y2: 348.4573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 520.8,
    y: 342.4,
    style: {
      fill: "url(#SVGID_00000178173053581115873090000004529125543861234071_)"
    },
    width: 12.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063599575352653821950000000492964032452457097_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 369.0381,
    x2: 514.197,
    y2: 369.0381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 548.6,
    y: 363,
    style: {
      fill: "url(#SVGID_00000063599575352653821950000000492964032452457097_)"
    },
    width: 12.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047050623699822989180000018282731952766781583_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 369.0381,
    x2: 514.197,
    y2: 369.0381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 520.8,
    y: 363,
    style: {
      fill: "url(#SVGID_00000047050623699822989180000018282731952766781583_)"
    },
    width: 12.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002379398811816173870000001378609082955299978_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1051,
    y1: 348.4546,
    x2: 514.197,
    y2: 348.4546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002379398811816173870000001378609082955299978_)"
    },
    d: "M496.3,328.3v67.3h85.6l0-94.2h-78.8 L496.3,328.3z M507.5,329.7l4.4-17.1h58.8l0,71.8h-63.2V329.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSampleCourse);
export default __webpack_public_path__ + "static/media/icon-sample-course.203bc477df13c1720b5f496cb9c8e295.svg";
export { ForwardRef as ReactComponent };